import React from 'react';
import Segment from "./Segment";

const Timeline = ({ data, activeSegment, handleSegmentHover }) => {

  const segments = data.map(segmentData => (
    <Segment
      key={segmentData.id}
      data={segmentData}
      activeSegment={activeSegment}
      handleSegmentHover={handleSegmentHover}
    />
  ));

  return (
    <div className={"timeline-container"}>
      {segments}
    </div>
  );
}

export default Timeline;
